import React, { ReactNode } from "react";
import { Box } from "@mui/material";

interface StandardWrapperProps {
  children: ReactNode;

  [x: string]: any;
}

const StandardWrapper: React.FC<StandardWrapperProps> = ({
  children,
  ...rest
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        backgroundColor: (theme) => theme.palette.background.default,
        paddingTop: { xs: 14, sm: 17.5 },
        "& .mainContent": {
          display: "flex",
          flexDirection: "column",
          position: "relative",
          width: { lg: "calc(100% - 340px)" },
          transition: "all 0.5s ease",
          ml: { md: "10px", lg: "300px" },
          mr: { md: "40px" },
        },
        "&.appMainFixedFooter": {
          pb: { xs: 12, xl: 14.5 },
        },
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default StandardWrapper;
